





















































import path from 'path'
import { Component, Vue, Watch } from 'vue-property-decorator'
import VueRouter, { Route, RouteRecord, RouteConfig } from 'vue-router'
import { PermissionStoreModule as permissionStore } from '@/shared/config/store/permission-store'
import { TagsViewStoreModule as tagsViewStore, ITagViewState } from '@/shared/config/store/tags-view-store'
import ScrollPane from './ScrollPane.vue'

@Component({
  name: 'TagsView',
  components: {
    ScrollPane
  }
})
export default class extends Vue {
  private visible: boolean = false
  private top: number = 0
  private left: number = 0
  private selectedTag: ITagViewState = {}
  private affixTags: ITagViewState[] = []

  get visitedViews() {
    return tagsViewStore.visitedViews
  }

  get routes() {
    return permissionStore.routes
  }

  @Watch('$route')
  private onRouteChange() {
    this.addTags()
    this.moveToCurrentTag()
  }

  @Watch('visible')
  private onVisibleChange(value: boolean) {
    if (value) {
      document.body.addEventListener('click', this.closeMenu)
    } else {
      document.body.removeEventListener('click', this.closeMenu)
    }
  }

  mounted() {
    this.initTags()
    this.addTags()
  }

  public printTitle(text: string) {
    const translationKey = `route.${text}`;
    return this.$te(translationKey) ? this.$t(translationKey) : text;
  }

  private isActive(route: ITagViewState) {
    return route.fullPath === this.$route.fullPath
  }

  private isAffix(tag: ITagViewState) {
    return tag.meta && tag.meta.affix
  }

  private filterAffixTags(routes: RouteConfig[], basePath = '/') {
    let tags: ITagViewState[] = []
    routes.forEach(route => {
      if (route.meta && route.meta.affix) {
        const tagPath = path.resolve(basePath, route.path)
        tags.push({
          fullPath: tagPath,
          path: tagPath,
          name: route.name,
          meta: { ...route.meta }
        })
      }
      if (route.children) {
        const childTags = this.filterAffixTags(route.children, route.path)
        if (childTags.length >= 1) {
          tags = [...tags, ...childTags]
        }
      }
    })
    return tags
  }

  private initTags() {
    this.affixTags = this.filterAffixTags(this.routes)
    for (const tag of this.affixTags) {
      // Must have tag name
      if (tag.name) {
        tagsViewStore.addVisitedView(tag)
      }
    }
  }

  private addTags() {
    const { name } = this.$route
    if (name) {
      tagsViewStore.addView(this.$route)
    }
    return false
  }

  private moveToCurrentTag() {
    const tags = this.$refs.tag as any[] // TODO: better typescript support for router-link
    this.$nextTick(() => {
      if (!tags) return;
      for (const tag of tags) {
        if ((tag.to as ITagViewState).path === this.$route.path) {
          (this.$refs.scrollPane as ScrollPane).moveToTarget(tag as any)
          // When query is different then update
          if ((tag.to as ITagViewState).fullPath !== this.$route.fullPath) {
            tagsViewStore.updateVisitedView(this.$route)
          }
          break
        }
      }
    })
  }

  private refreshSelectedTag(view: ITagViewState) {
    tagsViewStore.delCachedView(view)
    const { fullPath } = view
    this.$nextTick(() => {
      this.$router.replace({
        path: '/redirect' + fullPath
      })
    })
  }

  private closeSelectedTag(view: ITagViewState) {
    tagsViewStore.delView(view)
    if (this.isActive(view)) {
      this.toLastView(tagsViewStore.visitedViews, view)
    }
  }

  private closeOthersTags() {
    this.$router.push(this.selectedTag)
    tagsViewStore.delOthersViews(this.selectedTag)
    this.moveToCurrentTag()
  }

  private closeAllTags(view: ITagViewState) {
    tagsViewStore.delAllViews()
    if (this.affixTags.some(tag => tag.path === this.$route.path)) {
      return
    }
    this.toLastView(tagsViewStore.visitedViews, view)
  }

  private toLastView(visitedViews: ITagViewState[], view: ITagViewState) {
    const latestView = visitedViews.slice(-1)[0]
    if (latestView) {
      this.$router.push(latestView)
    } else {
      // Default redirect to the home page if there is no tags-view, adjust it if you want
      if (view.name === 'Dashboard') {
        // to reload home page
        this.$router.replace({ path: '/redirect' + view.fullPath })
      } else {
        this.$router.push('/')
      }
    }
  }

  private openMenu(tag: ITagViewState, e: MouseEvent) {
    const menuMinWidth = 105
    const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
    const offsetWidth = (this.$el as HTMLElement).offsetWidth // container width
    const maxLeft = offsetWidth - menuMinWidth // left boundary
    const left = e.clientX - offsetLeft + 15 // 15: margin right
    if (left > maxLeft) {
      this.left = maxLeft
    } else {
      this.left = left
    }
    this.top = e.clientY
    this.visible = true
    this.selectedTag = tag
  }

  private closeMenu() {
    this.visible = false
  }
}
